import { TrendsApi } from '../esl';
import { AdminApiClientConfigFactory } from './AdminApiClientConfigFactory';
export class TrendsService {
    trendsApi;
    constructor(trendsApi) {
        this.trendsApi = trendsApi;
    }
    static create = (apiBaseUrl, authToken) => {
        return new TrendsService(TrendsApi.create(apiBaseUrl, AdminApiClientConfigFactory.create(authToken)));
    };
    getTrends = async (healthCategory) => {
        const result = await this.trendsApi.getTrends(healthCategory);
        return result.data;
    };
}
